const ElevShared = require("../../../../shared/ElevShared");
const ElevPrices = require("./ElevPrices");
const ElevHelpers = require("./ElevHelpers");
const {$each, toggleClass, onClickOrEnter, removeEl} = require("./ElevHelpers");

const {
	getGradeSetItems,
	getScienceGradeSetItems,
	getBundleItems,
	loadCartFromStorage,
	modifyCart,
	addItemsToCart,
	showAddToCartModal,
	getTotalQuantity,
	canAddSubToCart,
} = require("./CartUtil");

const {
	cleanSubscriptionName,
	isBadNameInSubscriptions,
} = require("../../../../shared/StoreUtil");

const {track} = require("../../../core/util/Mixpanel");

//
// JS for single book page (with edits to make compatible for single level page)
//

function getItemsForBookOption(setType, grade, hash, quantity, subName) {
	const puzzleItem = [
		{sku: "beast-" + grade + "-puzzles", quantity, options: {}},
	];
	if (!quantity) {
		return [];
	} else if (setType === "guide") {
		return [{sku: "beast-" + hash.toLowerCase(), quantity, options: {}}];
	} else if (setType === "practice") {
		return [
			{sku: "beast-" + hash.toLowerCase() + "-practice", quantity, options: {}},
		];
	} else if (setType === "guide-practice") {
		return [
			{sku: "beast-" + hash.toLowerCase(), quantity, options: {}},
			{sku: "beast-" + hash.toLowerCase() + "-practice", quantity, options: {}},
		];
	} else if (setType === "puzzle") {
		return puzzleItem;
	} else if (setType === "science") {
		return [
			{
				sku: "beast-" + hash.toLowerCase().substring(0, 2) + "-science",
				quantity,
				options: {},
			},
		];
	} else if (
		[3, 4]
			.map(gradeNumber => `grade-set-science-${gradeNumber}`)
			.includes(setType)
	) {
		return getScienceGradeSetItems(grade, quantity);
	} else if (setType === "grade-set") {
		return getGradeSetItems(grade, quantity);
	} else if (setType === "grade-set-plus-puzzles") {
		return getGradeSetItems(grade, quantity).concat([
			{sku: "beast-" + grade + "-puzzles", quantity, options: {}},
		]);
	} else if (setType === "bundle") {
		return getBundleItems(subName, [grade]);
	} else if (setType === "bundle-puzzles") {
		return getBundleItems(subName, [grade]).concat(puzzleItem);
	}
	return [];
}

/* Remove any bundle options from dropdown */

function removeBundleOptions() {
	const bookDropdown =
		document.querySelector(".ba11-p-booksingle-overview-buy-dropdown") ||
		document.querySelector(".product-select-field");
	if (!bookDropdown) return;
	const bundleOption = bookDropdown.querySelector("option[value='bundle']");
	const bundlePuzzleOption = bookDropdown.querySelector(
		"option[value='bundle-puzzles']"
	);

	if (!bundleOption) return;
	removeEl(bundleOption);
	if (!bundlePuzzleOption) return;
	removeEl(bundlePuzzleOption);
}

function setupBookBuy(el) {
	const dropdown =
		el.querySelector(".ba11-p-booksingle-overview-buy-dropdown") ||
		el.querySelector(".product-select-field");
	const qtyContainerEl =
		el.querySelector(".ba11-p-booksingle-overview-buy-qty-input") ||
		el.querySelector(".product-selection-qty");
	const qtyInput =
		el.querySelector(".ba11-p-booksingle-overview-buy-qty-sel") ||
		el.querySelector(`input[name="commerce-add-to-cart-quantity-input"]`);
	const bundleContainerEl =
		el.querySelector(".ba11-p-booksingle-overview-buy-bundle-input") ||
		el.querySelector(".product-bundle-input-wrapper");
	const bundleInput =
		el.querySelector(".ba11-p-booksingle-overview-buy-bundle-name") ||
		el.querySelector(".product-bundle-name-input");
	const nameErrorEl =
		el.querySelector(".ba11-p-booksingle-overview-buy-bundle-name-error") ||
		el.querySelector(".product-bundle-name-error");
	const addButton =
		el.querySelector(".ba11-p-booksingle-overview-buy-button") ||
		el.querySelector(".product-top-btn");
	const priceEl =
		el.querySelector(".ba11-p-booksingle-overview-buy-price") ||
		el.querySelector(".product-info-price");

	ElevHelpers.preventBadQtyInput(qtyInput, 2);

	const getCurrentItems = function() {
		const setType = dropdown.value;
		const grade = parseInt(dropdown.dataset.grade);
		const hash = dropdown.dataset.hash;
		let quantity = 1;
		let subName = "";
		if (setType.includes("bundle")) {
			subName = bundleInput.value;
		} else {
			const quantityRaw = parseInt(qtyInput.value);
			quantity = ElevPrices.fixQuantity(quantityRaw);
			if (quantity !== quantityRaw) {
				qtyInput.value = quantity;
			}
		}
		const itemsToAdd = getItemsForBookOption(
			setType,
			grade,
			hash,
			quantity,
			subName
		);
		return itemsToAdd;
	};

	const updateShownPrice = function() {
		const items = getCurrentItems();
		const total = ElevPrices.calculateTotalItemPrice(items);
		priceEl.innerHTML = "$" + total.toFixed(2);
	};

	qtyInput.addEventListener("change", function(evt) {
		updateShownPrice();
	});

	dropdown.addEventListener("change", function(evt) {
		updateInfoView();
		updateShownPrice();
	});

	/* Check if customer has reached max number of subscriptions in cart,
	   and if so, remove bundle options from dropdown. */
	const handleMaxSubsReached = () => {
		if (!canAddSubToCart()) {
			removeBundleOptions();
		}
	};

	const setInitialDropdown = () => {
		const urlParts = window.location.pathname.split("/");
		const lastPart = urlParts[urlParts.length - 1];
		const options = [
			"guide",
			"practice",
			"guide-practice",
			"fullset",
			"fullset-plus-puzzles",
		];
		if (options.includes(lastPart)) {
			// change "full" to "grade-" here so we don't have to change it everywhere
			// in code
			const optRepl = lastPart.replace("level", "grade");
			for (let i = 0; i < dropdown.options.length; i++) {
				if (dropdown.options[i].value === optRepl) {
					dropdown.options[i].selected = true;
					break;
				}
			}
		}
	};

	const updateInfoView = () => {
		handleMaxSubsReached();
		const newSelValue = dropdown.value;
		$each(document, ".ba11-p-booksingle-overview-images-inner", function(
			imagesEl
		) {
			$each(imagesEl, "[data-selvalue]", function(selValueEl) {
				const selValue = selValueEl.getAttribute("data-selvalue");
				toggleClass(selValueEl, "ba11--visible", selValue === newSelValue);
			});
		});
		toggleClass(
			bundleContainerEl,
			"ba11--visible",
			newSelValue.includes("bundle")
		);
		toggleClass(
			qtyContainerEl,
			"ba11--visible",
			!newSelValue.includes("bundle")
		);
		const extraNote = document.querySelector(".product-puzzle-note");
		if (extraNote) {
			toggleClass(extraNote, "ba11--visible", !newSelValue.includes("puzzle"));
		}
	};

	const validate = function() {
		const nameErrors = [];
		if (dropdown.value.includes("bundle")) {
			const usedNames = [];
			const cart = loadCartFromStorage();
			cart.items.forEach(item => {
				if (item.options.displayName)
					usedNames.push(cleanSubscriptionName(item.options.displayName));
			});
			const name = bundleInput.value;
			if (!name) nameErrors.push("E_NO_NAME");

			const cleanedName = cleanSubscriptionName(name);
			if (!cleanedName) nameErrors.push("E_DISALLOWED_CHARACTERS");

			const error = isBadNameInSubscriptions(
				usedNames,
				cleanedName,
				true,
				true
			);
			if (error) nameErrors.push(error);
		}

		if (nameErrors.length) {
			nameErrorEl.innerText = `* ${ElevShared.copyForStudentNameErrors(
				nameErrors[0]
			)}`;
		}
		toggleClass(nameErrorEl, "ba11--hidden", !nameErrors.length);
		toggleClass(bundleInput, "--error", nameErrors.length);
		return !nameErrors.length;
	};

	onClickOrEnter(addButton, evt => {
		if (!validate()) return;
		const itemsToAdd = getCurrentItems();

		if (!itemsToAdd.length) {
			return;
		}
		modifyCart(c => {
			addItemsToCart(itemsToAdd, c);
		});
		const setType = dropdown.value;
		if (setType.includes("bundle")) {
			track("Subscription Added to Cart", {
				page: "book",
				enrollType: "bundle",
				itemLevel: dropdown.dataset.grade,
			});
			showAddToCartModal(1, "bundle", addButton);
		} else if (setType.includes("grade-set-science")) {
			showAddToCartModal(1, "bundle", addButton);
		} else {
			showAddToCartModal(getTotalQuantity(itemsToAdd), "book", addButton);
		}
		updateInfoView();
	});

	// wait for browser cache then apply any cached select
	setTimeout(() => {
		setInitialDropdown();
		updateInfoView();
		updateShownPrice();
	}, 0);
}

function removeBundlesFromDropdown(bookDropdown) {
	const bundleOption = bookDropdown.querySelector("option[value='bundle']");
	const bundlePuzzleOption = bookDropdown.querySelector(
		"option[value='bundle-puzzles']"
	);
	if (!bundleOption) return;
	removeEl(bundleOption);
	if (!bundlePuzzleOption) return;
	removeEl(bundlePuzzleOption);
}

function setupBookBuyPostAuth(user) {
	if (!user) return;
	removeBundleOptions();
}

function setupBookBuyForClassWallet() {
	const bookDropdown =
		document.querySelector(".ba11-p-booksingle-overview-buy-dropdown") ||
		document.querySelector(".product-select-field");
	if (!bookDropdown) return;
	removeBundlesFromDropdown(bookDropdown);
}

module.exports = {
	setupBookBuy,
	setupBookBuyPostAuth,
	setupBookBuyForClassWallet,
};
